import { UserBase } from "./base";
export class Organizer extends UserBase {
    constructor(params) {
        super(params);
    }
}
